export const GET_ACCOUNTS_DATA = 'GET_ACCOUNTS_DATA';
export type GET_ACCOUNTS_DATA = typeof GET_ACCOUNTS_DATA;

export const GET_AGENTS_LIST= 'GET_AGENTS_LIST';
export type GET_AGENTS_LIST = typeof GET_AGENTS_LIST;
